import { initializeApp } from "firebase/app";
import { 
  getFirestore, 
  collection, 
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  setDoc, 
  getDoc, 
  query, 
  where, 
  orderBy 
} from "firebase/firestore";
import { 
  getAuth, 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  sendEmailVerification, 
  onAuthStateChanged, 
  signOut 
} from "firebase/auth";

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// Collections
const chaptersCollection = collection(db, "chapters");
const manifestoLinesCollection = collection(db, "manifestoLines");
const artifactsCollection = collection(db, "artifacts");
const usersCollection = collection(db, "users");
const userProgressCollection = collection(db, "userProgress");
const sectionsCollection = collection(db, "sections");
const heroContentCollection = collection(db, "heroContent");
const scrollingTextCollection = collection(db, "scrollingText");
const addressesCollection = collection(db, "addresses");
const transactionsCollection = collection(db, "transactions");

export { 
  db, 
  auth,
  chaptersCollection,
  manifestoLinesCollection,
  artifactsCollection,
  usersCollection,
  userProgressCollection,
  sectionsCollection,
  heroContentCollection,
  scrollingTextCollection,
  addressesCollection,
  collection,
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  setDoc, 
  getDoc, 
  query, 
  where, 
  orderBy,
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  sendEmailVerification, 
  onAuthStateChanged, 
  signOut,
  transactionsCollection
};